const YEAR_REGEX = /\b(?:202[4-9]|203[0-9])\b/;

export function containsHardcodedYear(value: string | null | undefined): boolean {
  if (!value) return false;
  const currentYear = String(new Date().getFullYear());
  const stripped = value
    .replace(/\{DATE:Y\}/g, '')
    .replace(new RegExp(`\\b${currentYear}\\b`, 'g'), '');
  return YEAR_REGEX.test(stripped);
}

export const YEAR_WARNING = 'Jahreszahl erkannt — bitte {DATE:Y} als Platzhalter verwenden';
